import React from 'react';

interface GlassPanelProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
}

const GlassPanel: React.FC<GlassPanelProps> = ({ children, className = '', hover = true }) => {
  return (
    <div className={`${hover ? 'glass-panel' : 'glass-panel-static'} ${className}`}>
      {children}
    </div>
  );
};

export default GlassPanel;
